import axios from "axios";
import config from "../../config";
import Cookies from "js-cookie";

const baseUrl = config.baseUrl; // URL base de tu API
const baseEnpoint = "/api/entregas";
const salidaSostenibilidad = "/api/entregas/entrega"; // Endpoint para resgistrar salida de productos
const cargaDocumentoEndpoint = "/api/entregas/formato-entrega/upload"; // Endpoint para cargar documento de entrega
const deleteProductoEntrega = "/api/entregas/remove-producto"; // Endpoint para eliminar un producto de una entrega

// Crear una instancia de Axios con la configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Crear una nueva salida de bodega
export const createSalidaBodegaService = async (salidaData) => {
  try {
    const response = await api.post(`${salidaSostenibilidad}`, salidaData);
    return response.data; // Devuelve la respuesta del backend (insertId y message)
  } catch (error) {
    console.error(
      "❌ Error al registrar salida de bodega:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al registrar salida de bodega",
    };
  }
};

export const getsalidas = async () => {
  try {
    const response = await api.get(`${baseEnpoint}`);
    return response.data; // Devuelve los datos del servicio
  } catch (error) {
    console.error(
      "Error al obtener las entregas de sostenibilidad:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message:
        error.message || "Error al obtener las engtregas  de sostenibilidad",
    };
  }
};

export const uploadFormatoEntrega = async (idRegistro, estado, blobArchivo) => {
  try {
    if (!idRegistro) throw new Error("ID de registro es requerido");
    if (!estado) throw new Error("estado de registro es requerido");
    if (!blobArchivo) throw new Error("Archivo es requerido");
    const formData = new FormData();

    formData.append("id_registro", idRegistro);
    formData.append("estado", estado);

    if (blobArchivo) {
      const file = new File(
        [blobArchivo],
        `formato_entrega_${idRegistro}.pdf`,
        {
          type: "application/pdf",
        }
      );
      formData.append("archivo", file);
    }

    const response = await api.post(`${cargaDocumentoEndpoint}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error al subir formato de la entrega:", error);

    return {
      status: error.response ? error.response.status : 500,
      // Si la respuesta viene del backend, toma el mensaje o el errorCode que envía
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al subir formato de la entrega",
      errorCode: error.response?.data?.errorCode || null,
    };
  }
};

export const getSalidasByIds = async (ids) => {
  try {
    const response = await api.post(`${baseEnpoint}`, { ids });
    return response.data; // ✅ Devuelve el JSON de la API
  } catch (error) {
    console.error(
      "Error al obtener las entregas por ids:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al obtener las entregas por ids",
    };
  }
};

// Eliminar una salida por OID
export const deleteSalida = async (oid) => {
  try {
    const response = await api.delete(`${salidaSostenibilidad}/${oid}`);
    return response.data; // ✅ Devuelve la respuesta del backend
  } catch (error) {
    console.error("Error al eliminar la entrega:", error.message || error);
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al eliminar la entrega",
    };
  }
};

// Service para eliminar un producto de una salida
export const deleteProductoDeSalida = async ({
  po_producto_oid,
  asignaciones,
  id_salida,
}) => {
  try {
    const response = await api.post(`${deleteProductoEntrega}`, {
      po_producto_oid,
      asignaciones,
      id_salida,
    });

    return response.data; // ✅ Devuelve la respuesta del backend
  } catch (error) {
    console.error(
      "Error al eliminar producto de la salida:",
      error.message || error
    );

    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al eliminar producto de la salida",
    };
  }
};

// ✅ Actualizar una salida de bodega
export const updateSalidaBodegaService = async (oid, salidaData) => {
  try {
    const response = await api.put(
      `${salidaSostenibilidad}/${oid}`,
      salidaData
    );
    return response.data; // Devuelve la respuesta del backend (message, etc.)
  } catch (error) {
    console.error(
      "❌ Error al actualizar salida de bodega:",
      error.message || error
    );
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al actualizar salida de bodega",
    };
  }
};
